import { useFieldValidity } from '../../../pages/ApplicationV3/hooks/useFieldValidity';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import styles from './InputField.module.scss';

export const Cypress_data = {
  inputField: 'base-input-field',
  wrapper: 'base-input-field-wrapper',
  label: 'base-input-field-label',
};

export type InputType =
  | 'text'
  | 'email'
  | 'password'
  | 'number'
  | 'tel'
  | 'url'
  | 'search'
  | 'date'
  | 'datetime-local'
  | 'time'
  | 'month'
  | 'week'
  | 'color'
  | 'file'
  | 'hidden'
  | 'range';

interface InputFieldProps {
  name: string;
  label?: string;
  type?: InputType;
  placeholder?: string;
  required?: boolean;
  hideInputField?: boolean;
  min?: string;
  max?: string;
}

const InputField = ({
  name,
  label,
  type,
  placeholder,
  required,
  hideInputField,
  min,
  max,
}: InputFieldProps) => {
  const { register, watch } = useFormContext();
  const { isValid, invalid, error } = useFieldValidity(name);
  const value = watch(name) || '';
  return (
    <div data-cy={Cypress_data.wrapper} className={styles.wrapper}>
      {label && (
        <label
          className={styles.label}
          htmlFor={name}
          data-cy={Cypress_data.label}
        >
          {`${label}${required ? ' *' : ''}`}
        </label>
      )}
      {!hideInputField && (
        <input
          id={name}
          {...register(name)}
          onBlur={(e) => {
            register(name).onBlur(e);
          }}
          value={value}
          name={name}
          type={type}
          placeholder={placeholder}
          min={min}
          max={max}
          className={classNames(styles.inputField, {
            [styles.isValid]: isValid,
            [styles.isInvalid]: invalid,
          })}
          data-cy={Cypress_data.inputField}
        />
      )}
      {error && <span className={styles.errorText}>{error.message}</span>}
    </div>
  );
};

export default InputField;
